import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Box } from '@hub-la/design-system';

const ContainerShadow = ({
  children
}) => {
  const {
    palette
  } = useUtility();
  return jsxs(Box, Object.assign({
    textAlign: "center",
    px: [2, 14],
    py: 12,
    borderRadius: 4,
    position: "relative"
  }, {
    children: [children, jsx(Box, Object.assign({
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: 3,
      border: "2px solid transparent",
      tabIndex: -1,
      zIndex: -1,
      style: {
        inset: 0,
        background: `linear-gradient(to bottom, ${palette('surfaceAt3')}, transparent) border-box`,
        WebkitMask: `linear-gradient(${palette('onPrimary')} 0 0) padding-box,
          linear-gradient(${palette('onPrimary')} 0 0)`,
        WebkitMaskComposite: 'destination-out',
        maskComposite: 'exclude'
      }
    }, {
      children: null
    }))]
  }));
};

export { ContainerShadow };
